import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/checkout";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = document.getElementById("hero-cta");
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-24" data-mp="gpm0d632g70p">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:pb-5" data-id="element-25" data-mp="gob0vignllfe">
          <a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-md items-center justify-between gap-3 rounded-2xl bg-cta py-3 pl-5 pr-3 text-white shadow-[0_10px_30px_-5px_rgba(14,107,49,0.6)] ring-2 ring-white motion-safe:animate-shake focus:outline-none focus-visible:ring-4 focus-visible:ring-gold" data-id="element-26" data-mp="14eokqlp34dyw">
            <span className="flex flex-col" data-id="element-27" data-mp="26bqomqviqm7c">
              <span className="text-[15px] font-extrabold uppercase leading-tight tracking-wide" data-id="element-28" data-mp="26afmevhq1mic">Get instant access</span>
              <span className="text-xs font-semibold text-white/90" data-id="element-29" data-mp="1rd534zyu7cc2">Complete collection · Only $27 USD</span>
            </span>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-cta" data-id="element-30" data-mp="1idrrq1r5kdop">
              <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="1ncl3npqsjwmr" />
            </span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}